import React from "react";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import {  AuthContext } from "./AuthProvider";

export const Logout = () => {
    var auth = React.useContext(AuthContext); 

    auth.logout();
    return <AbpnSpinner/>;
}